import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const cargoNegativeStowedWeightHardRule: StowageRuleBM = {
    id: StowageRuleId.CargoNegativeStowedWeightHardRule,
    name: 'Stowed weight cannot be negative',
    lastUpdatedUtc: '2024-09-16T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Stowed weight',
                            fieldPath: 'getCargoStowedWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: '0',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Cargo,
                    operator: StowageRulePropertyOperator.IsLessThan,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'Negative stowed weight',
    },
};
